import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/header'
import Footer from '../components/Footer'
import Menu from '../components/menu'
import './index.css';
let favicon = require('../../src/assets/img/favicon.ico')

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        {
          name: 'description',
          content: 'Historiarg: Historia Argentina! Sucesos, biografías, libros recomendados, videos, audios, documentos y artículos.',
        },
        { name: 'keywords',
          content: 'historia argentina, historiarg, resumen, resumenes, estudiar, videos, libros, guerra malvinas, bicentenario, evita, San Martin, Manuel Belgrano, Mariano Moreno, Juan Manuel de Rosas, federales, unitarios' },
      ]}
      link={[
        { rel: 'shortcut icon', type: 'image/png', href: `${favicon}` }
      ]}
    />
    <Header siteTitle={data.site.siteMetadata.title} />
    <Menu />
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '0px 1.0875rem 1.45rem',
        paddingTop: 0,
        overflow: 'hidden'
      }}
    >
      {children()}
    </div>
    <Footer />
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js